import React, { useEffect, useState }   from "react";
import {Link}                           from "react-router-dom";

import "./navigation.scss";

import defaultImage from './gear.svg'
import {scrollToTop}                    from "@Xpresso/routes/omni-search/omni-search-layout/common/common.js";

export const Navigation = ({addSearchHistoryRecord, combinedItems}) => {

    const handleAddSearchClick = (item) => {
        addSearchHistoryRecord({
            search_handler: "navigation",
            suggestion_data: item.url,
            suggestion_name: item.name,
            suggestion_type: "navigation",
        })
        scrollToTop()
    }
    
    return (
        <div className="navigation-nvg77">
            <div className="navigation-section">
                <div className="nav-grid">
                    {combinedItems?.map((item) => (
                        item.url.startsWith("http") ? (
                            <a 
                                href={item.url} 
                                className="card" 
                                key={item.name}
                                onClick={() => handleAddSearchClick(item)}
                            >
                                <img src={item.icon ?? item.defaultIcon ?? defaultImage} alt={item.name} />
                                <div className="content">
                                    <div className="name">{item.name}</div>
                                    <div className="description">{item.description}</div>
                                </div>
                            </a>
                        ) : (
                            <Link 
                                to={item.url} 
                                className="card" 
                                key={item.name}
                                onClick={() => handleAddSearchClick(item)}
                            >
                                <img src={item.icon ?? item.defaultIcon ?? defaultImage} alt={item.name} />
                                <div className="content">
                                    <div className="name">{item.name}</div>
                                    <div className="description">{item.description}</div>
                                </div>
                            </Link>
                        )
                    ))}
                </div>
            </div>
        </div>
    )
}
